import React, { useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import DealPerceptionForm from '../../../../../../components/DealPerceptionForm';
import LoadMask from '../../../../../../components/LoadMask';
import {DateHelpers} from '../../../../../../helpers/date-helpers';
import LinkBuilder from '../../../../../../helpers/link-builder';

const TypeFirmPortfolioMark = props => {
  const {
    post: {
      PortfolioID,
      OwnerFirmID,
      OwnerFirmName,
      OwnerFirmUrlAlias,
      FirmName,
      FirmUrlAlias,
      UserFirmName,
      UserFirmUrlAlias,
      UserFirmActive,
      AllowRate,
      NewsFeedDateAdd,
      Date,
      Mark,
    },
    actions: { handleClickFirmPortfolioDeal },
  } = props;

  const [isLoadMaskVisible, setLoadMaskVisible] = useState(false);

  const date = useMemo(() => {
    const [year] = DateHelpers.getDateArray(Date);
    const currentYear = DateHelpers.getCurrentYear();

    return currentYear > Number(year)
      ? DateHelpers.getMonthNameDayYearFormat(Date)
      : NewsFeedDateAdd;
  }, [Date, NewsFeedDateAdd]);

  const userFirm = useMemo(
    () =>
      UserFirmName ? (
        UserFirmActive === 'Yes' ? (
          <NavLink to={LinkBuilder.getFirmLink(UserFirmUrlAlias)}>
            {UserFirmName}
          </NavLink>
        ) : (
          <span className="feed-post-content__hero--span">{UserFirmName}</span>
        )
      ) : null,
    [UserFirmName, UserFirmUrlAlias, UserFirmActive]
  );

  const handleClickGoodDealButton = () => {
    setLoadMaskVisible(true);
    handleClickFirmPortfolioDeal(OwnerFirmID, PortfolioID, 1);
  };

  const handleClickBadDealButton = () => {
    setLoadMaskVisible(true);
    handleClickFirmPortfolioDeal(OwnerFirmID, PortfolioID, -1);
  };

  return (
    <div className="feed-post-content__inner feed-post-content__inner--typed">
      {isLoadMaskVisible && <LoadMask relative />}
      <div className="feed-post-content__top">
        <NavLink to={LinkBuilder.getFirmLink(OwnerFirmUrlAlias)}>
          {OwnerFirmName}'s
        </NavLink>
        <div className="feed-post-content__text">investment in</div>
        <NavLink to={LinkBuilder.getFirmLink(FirmUrlAlias)}>{FirmName}</NavLink>
        <div className="feed-post-content__text">
          {' '}
          was rated a {Mark.toLowerCase()} deal{userFirm ? ' by ' : ''}
        </div>
        {userFirm}
      </div>
      <div className="feed-post-content__date">{date}</div>
      {AllowRate === 'Yes' && (
        <div className="feed-post-content__middle">
          <DealPerceptionForm
            onClickGoodDeal={handleClickGoodDealButton}
            onClickBadDeal={handleClickBadDealButton}
          />
        </div>
      )}
    </div>
  );
};

export default TypeFirmPortfolioMark;
